import { render, staticRenderFns } from "./Documentacao.vue?vue&type=template&id=2902f7da&"
import script from "./Documentacao.vue?vue&type=script&lang=js&"
export * from "./Documentacao.vue?vue&type=script&lang=js&"
import style0 from "./Documentacao.vue?vue&type=style&index=0&id=2902f7da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports